import { CARDART, type EndpointBaseType } from '@/defs/misc'

type Props =
  | {
      base?: EndpointBaseType
      cause?: unknown
      message: string
      statusCode: number
    }
  | string

export class EDHRECError extends Error {
  statusCode: number
  base?: EndpointBaseType
  // Next.js strips error.message in production but preserves error.digest
  digest: string

  constructor(props: Props) {
    const { base, cause, message, statusCode } = typeof props === 'string' ? { message: props, statusCode: 500 } : props
    super(message, { cause })
    this.base = base
    this.statusCode = statusCode
    this.name = 'EDHRECError'
    this.digest = `EDHREC_HTTP_${statusCode}`
  }
}

export type ErrorMetaType = {
  cardart: string
  description: string
  title: string
}

export const DEFAULT_ERROR_META: ErrorMetaType = {
  cardart: CARDART.VANISH_INTO_MEMORY,
  description: 'The application cannot process your request',
  title: 'Application Error',
}

export const ERROR_META: Record<number, ErrorMetaType> = {
  400: {
    cardart: CARDART.VANISH_INTO_MEMORY,
    description: 'The server cannot process your request',
    title: '400 Bad Request',
  },
  404: {
    cardart: CARDART.TOTALLY_LOST,
    description: 'That page could not be found',
    title: '404 Not Found',
  },
  500: {
    cardart: CARDART.VANISH_INTO_MEMORY,
    description: 'The server was unable to complete your request, please try again later',
    title: '500 Internal Server Error',
  },
}
